import { gql } from '@apollo/client';

export const viewReservationAdmin = gql`query viewReservationAdmin ($id:Int!){
  viewReservationAdmin(id:$id){
    id
    listId
    hostId
    guestId
    checkIn
    checkOut
    basePrice
    guestServiceFee
    hostServiceFee
    taxPrice
    taxValue
    reservationState
    total
    currency
    listTitle
    confirmationCode
    taxRate
    bookingType
    dayDifference
    paymentMethodId
    discount
    discountType
    createdAt
    updatedAt
    guests
    hostServiceFeeType
    hostServiceFeeValue
    guestServiceFeeType
    guestServiceFeeValue
    cleaningPrice
    isSpecialPriceAverage
    extraGuestFeeAmount
    extraGuestCount
    extraGuestFee
    cautionDeposit
    listData {
      id
      title
      bookingType
    }
    hostData {
      profileId
      firstName
      lastName
      phoneNumber
    }
    bookingSpecialPricing {
      id
      reservationId
      blockedDates
      isSpecialPrice
    }
    hostPayout {
      id
      payEmail
    }
    hostTransaction {
      id
      reservationId
    }
    guestData {
      profileId
      firstName
      lastName
      phoneNumber
    }
    transaction {
      id
      payerId
      payerEmail
      receiverEmail
      receiverId
      paymentType
      total
      currency
      transactionId
    }
    refundStatus {
      id
      receiverEmail
      total
      currency
      reservationId
    }
    cancellationDetails {
      id
      reservationId
      refundToGuest
      payoutToHost
      guestServiceFee
      hostServiceFee
      total
      currency
      status
      createdAt
      cancellationPolicy
      cancelledBy
      isTaxRefunded
    }
    hostUser{
      encryptEmail
    }
    guestUser{
      encryptEmail
    }
    status
  }
}`;